import { environment } from '@env/environment';
var ɵ0 = {
    siteKey: environment.recaptchaKey,
    badge: 'inline',
    theme: 'dark',
    size: 'invisible',
};
var TemplateModule = /** @class */ (function () {
    function TemplateModule() {
    }
    return TemplateModule;
}());
export { TemplateModule };
export { ɵ0 };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/template.module.ts.pre-build-optimizer.js